<div aria-hidden="true">
    <ng-template cdkPortalOutlet />
</div>
<div [attr.aria-live]="_live" [attr.role]="_role" [attr.id]="_liveElementId"></div>
